<div class="page-action-container" [ngClass]="{'file-upload-toolbar-mobile': !(!isShowNoDataTable && attachments.length === 0)}">
  <ng-container *ngIf="!isViewMode">
    <label
      pButton
      type="button"
      [label]="'SigvLibrary.Upload' | translate"
      icon="pi pi-cust-upload"
      class="p-button-action p-button-outlined p-content-button action-button"
      *ngIf="selectedAttachments.length === 0"
    >
      <input
        type="file"
        style="display: none"
        [multiple]="multiple"
        [accept]="accept"
        (change)="selectedUploadFiles($event)"
        #uploadFilesInput
      />
    </label>
    <button
      pButton
      type="button"
      [label]="'SigvLibrary.Delete' | translate"
      icon="pi pi-delete"
      class="p-button-action p-button-outlined p-content-button action-button"
      *ngIf="selectedAttachments.length > 0"
      (click)="deleteFiles()"
    ></button>
  </ng-container>
  <button
    pButton
    type="button"
    [label]="'SigvLibrary.Download' | translate"
    icon="pi pi-cust-download"
    class="p-button-action p-button-outlined p-content-button action-button"
    *ngIf="hasDownloadButton && isViewMode"
    [disabled]="selectedAttachments.length <= 0"
    (click)="downloadFiles()"
  ></button>
</div>
<div
  class="cfc-list cfc-max-height-560 table"
  *ngIf="!(!isShowNoDataTable && attachments.length === 0)"
>
  <p-table
    #attachmentTable
    [value]="attachments"
    [(selection)]="selectedAttachments"
    dataKey="fileDetailId"
    editMode="row"
    [ngClass]="{
      'table-empty': attachments.length === 0
    }"
    (onRowSelect)="selectChangeHandler()"
    (onRowUnselect)="selectChangeHandler()"
    (onHeaderCheckboxToggle)="selectChangeHandler()"
  >
  <ng-template pTemplate="caption">
    <div class="p-d-inline-flex p-ai-center">
      <p-tableHeaderCheckbox
        [ngClass]="{
          'p-datatable-icon-button-space': true,
          'p-datatable-header-checkbox-selected-some':
            isSelectedSomeSelectableRow
        }"
        [disabled]="
          isAttachmentsTableEditing() || hasEditableAttachments === false
        "
      ></p-tableHeaderCheckbox>
      <span>{{ "SigvLibrary.SelectAll" | translate }}</span>
    </div>
  </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngIf="!isViewMode || (hasDownloadButton && isViewMode)" style="width: 130px;">
          <div class="p-d-inline-flex p-ai-center">
            <p-tableHeaderCheckbox
              [ngClass]="{
                'p-datatable-icon-button-space': true,
                'p-datatable-header-checkbox-selected-some':
                  isSelectedSomeSelectableRow
              }"
              [disabled]="
                isAttachmentsTableEditing() || hasEditableAttachments === false
              "
            ></p-tableHeaderCheckbox>
            <span>{{ "SigvLibrary.SelectAll" | translate }}</span>
          </div>
        </th>
        <th style="width: 130px;">{{ "SigvLibrary.FileImage" | translate }}</th>
        <th style="width: 130px;">{{ "SigvLibrary.FileName" | translate }}</th>
        <th style="width: 130px;">{{ "SigvLibrary.FileDate" | translate }}</th>
        <th style="width: 130px;">{{ "SigvLibrary.FileSize" | translate }}</th>
        <th style="width: 130px;">
          {{ "SigvLibrary.FileDescription" | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-file
      let-editing="editing"
      let-rowIndex="rowIndex"
    >
      <tr
        [pSelectableRow]="file"
        [pSelectableRowIndex]="rowIndex"
        [pEditableRow]="file"
        [ngClass]="{ 'p-editing': editing }"
        [class.unselectable-bg]="
          isRowViewOnly(file.fileDetailId) || !file.isDownloadable
        "
      >
        <td *ngIf="hasDownloadButton && isViewMode">
          <p-tableCheckbox
            [value]="file"
            *ngIf="file.isDownloadable === true"
          ></p-tableCheckbox>
        </td>
        <td *ngIf="!isViewMode">
          <div class="p-d-flex p-ai-center p-jc-center">
            <p-tableCheckbox
              [value]="file"
              class="p-datatable-icon-button-space"
              [class.row-view-only]="isRowViewOnly(file.fileDetailId)"
              *ngIf="!editing"
              [disabled]="
                isAttachmentsTableEditing() || isRowViewOnly(file.fileDetailId)
              "
            ></p-tableCheckbox>
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              icon="pi pi-pen"
              (click)="onRowEditInit(file)"
              [class.row-view-only]="isRowViewOnly(file.fileDetailId)"
              class="p-button-rounded p-button-text"
              [disabled]="
                selectedAttachments.length > 0 ||
                isAttachmentsTableEditing() ||
                isRowViewOnly(file.fileDetailId)
              "
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              icon="pi pi-confirm"
              (click)="onRowEditSave(file, rowIndex)"
              class="p-button-rounded p-button-text p-button-success p-datatable-icon-button-space"
            ></button>
            <button
              *ngIf="editing"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              icon="pi pi-cancel"
              (click)="onRowEditCancel(file, rowIndex)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "SigvLibrary.FileImage" | translate }}</div>
          <div class="p-column-span">
            <a class="file-type-icon" (click)="openPdfFile(file)" [style.cursor]="isPDF(file) ? 'pointer':'default'">
              <i
                *ngIf="isShowFileTypeIcon(file.extension); else showImage"
                [ngClass]="getFileTypeIconStyleClassName(file.extension)"
              ></i>
            </a>
            <ng-template #showImage>
              <a
                href="javascript: void(0)"
                (click)="showGalleria(file.fileDetailId)"
              >
                <img
                  [src]="file.previewSrc | imageUrl | async"
                  [alt]="file.userSideName + file.extension"
                  style="max-width: 50px; max-height: 50px"
                />
              </a>
            </ng-template>
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "SigvLibrary.FileName" | translate }}</div>
          <div class="p-column-span">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input pInputText type="text" [(ngModel)]="file.userSideName" [maxLength]="255" />
              </ng-template>
              <ng-template pTemplate="output">
                <span *ngIf="file.isDownloadable !== true; else downloadable">
                  {{ file.userSideName }}{{ file.extension }}
                </span>
                <ng-template #downloadable>
                  <a
                    href="javascript: void(0)"
                    class="link"
                    (click)="downloadFile(file)"
                  >
                    {{ file.userSideName }}{{ file.extension }}
                  </a>
                </ng-template>
              </ng-template>
            </p-cellEditor>
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "SigvLibrary.FileDate" | translate }}</div>
          <div class="p-column-span">
            {{ file.createTime | date: dateFormat }}
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "SigvLibrary.FileSize" | translate }}</div>
          <div class="p-column-span">
            {{ file.fileSize | fileSize : 'K' | number: "1.0":"en-US" }} KB
          </div>
        </td>
        <td>
          <div class="p-column-title">{{ "SigvLibrary.FileDescription" | translate }}</div>
          <div class="p-column-span">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="file.description"
                  [maxLength]="100"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ file.description }}
              </ng-template>
            </p-cellEditor>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="file-empty-body-tr">
        <td [attr.colspan]="colspanLength">
          <div *ngIf="!isViewMode" class="file-empty-content">
            <img src="./assets/images/sigv-library/img-add.svg" />
            <a href="javascript: void(0)" (click)="openUploadFile($event)">{{
              "SigvLibrary.NeverUpload" | translate
            }}</a>
          </div>
          <div *ngIf="isViewMode">
            {{ "SigvLibrary.NoDataFound" | translate }}
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  header="{{'SigvLibrary.Upload' | translate}}"
  [(visible)]="isShowFilesUploadDialog"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-md sigv-file-center-dialog"
  appendTo="body"
  (onHide)="resetUploadFilesInput()"
>
  <form [formGroup]="uploadFilesForm">
    <div class="table">
      <p-table [value]="uploadFiles" dataKey="code">
        <ng-template pTemplate="header">
          <tr>
            <th>{{ "SigvLibrary.FileImage" | translate }}</th>
            <th>{{ "SigvLibrary.FileName" | translate }}</th>
            <th>{{ "SigvLibrary.FileSize" | translate }}</th>
            <th>
              {{ "SigvLibrary.FileDescription" | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-uploadFile>
          <tr>
            <td class="p-datatable-tbody-dialog-file-td p-p-3">
              <div class="p-datatable-dialog-file-img-title p-d-none">{{ "SigvLibrary.FileImage" | translate }}</div>
              <div class="p-column-span">
                <i
                  *ngIf="isShowFileTypeIcon(uploadFile.extension); else showImage"
                  [ngClass]="getFileTypeIconStyleClassName(uploadFile.extension)"
                ></i>
                <ng-template #showImage>
                  <img
                    [src]="uploadFile.previewSrc"
                    [alt]="uploadFile.file.name"
                    style="max-height: 50px; max-width: 50px"
                  />
                </ng-template>
              </div>
            </td>
            <td class="p-datatable-tbody-dialog-file-td p-p-3">
              <div class="p-column-title p-mb-2 p-d-none">{{ "SigvLibrary.FileName" | translate }}</div>
              <div class="p-column-span">{{ uploadFile.file.name }}</div>
            </td>
            <td class="p-datatable-tbody-dialog-file-td p-p-3">
              <div class="p-column-title p-d-none">{{ "SigvLibrary.FileSize" | translate }}</div>
              <div class="p-column-span">{{ uploadFile.file.size | fileSize : 'K' | number: "1.0":"en-US" }} KB</div>
            </td>
            <td class="p-datatable-tbody-dialog-file-td p-p-3">
              <div class="p-column-title p-mb-2 p-d-none">{{ "SigvLibrary.FileDescription" | translate }}</div>
              <input
                pInputText
                type="text"
                [placeholder]="'SigvLibrary.PleaseInput' | translate"
                [formControlName]="uploadFile.fileId"
                [maxlength]="100"
              />
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="p-d-flex p-jc-center">
      <button
        pButton
        type="button"
        [label]="'SigvLibrary.Cancel' | translate"
        class="p-button-secondary p-content-button p-mr-2"
        (click)="cancelUploadFiles()"
      ></button>
      <button
        pButton
        type="button"
        [label]="'SigvLibrary.Ok' | translate"
        class="p-content-button"
        (click)="submitUploadFiles()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-galleria
  [value]="attachmentImages"
  [(visible)]="displayGalleria"
  [responsiveOptions]="galleriaReponsiveSetting"
  [containerStyle]="{ 'max-width': '50%' }"
  [numVisible]="9"
  [circular]="true"
  [fullScreen]="true"
  [showItemNavigators]="true"
  [baseZIndex]="100000"
  [showThumbnailNavigators]="false"
  [(activeIndex)]="galleriaActiveIndex"
  (activeIndexChange)="resetImage($event)"
>
  <ng-template pTemplate="item" let-item>
    <div
      class="custom-image-container"
      (mousedown)="startDragging($event)"
      (mousemove)="onDragging($event)"
      (mouseup)="stopDragging()"
      (mouseleave)="stopDragging()"
    >
      <img
        [src]="item.previewSrc | imageUrl | async" style="max-width: 100%; display: block; max-height: calc(85vh - 60px); height: calc(85vh - 60px);"
        [style.transform]="'scale(' + zoomLevel + ') translate(' + translateX + 'px, ' + translateY + 'px) rotate(' + item.rotation + 'deg)'"
        (wheel)="onWheel($event)"
        (load)="onImageLoad($event)"
        draggable="false" />
    </div>
    <!-- 操作按鈕 -->
    <div class="control-buttons">
      <button pButton (click)="zoomIn()" icon="pi pi-plus"></button>
      <button pButton (click)="zoomOut()" icon="pi pi-minus"></button>
      <button pButton (click)="rotateLeft()" icon="pi pi-undo"></button>
      <button pButton (click)="rotateRight()" icon="pi pi-refresh"></button>
    </div>
  </ng-template>
  <ng-template pTemplate="thumbnail" let-item>
    <div class="p-grid p-nogutter p-justify-center">
      <img [src]="item.thumbnailImageSrc | imageUrl | async" />
    </div>
  </ng-template>
</p-galleria>

<!-- PFD預覽視窗 -->
<div *ngIf="showPdfPreview" class="pdf-preview-overlay" (wheel)="handleMouseWheel($event)">
  <div class="pdf-preview-modal">
    <button class="p-galleria-close p-link" (click)="closePdfPreview()">
      <span class="p-galleria-close-icon pi pi-times"></span>
    </button>
    <div class="control-buttons">
      <button pButton (click)="zoomInPDF()" icon="pi pi-plus"></button>
      <button pButton (click)="zoomOutPDF()" icon="pi pi-minus"></button>
      <button pButton (click)="rotatePDFleft()" icon="pi pi-undo"></button>
      <button pButton (click)="rotatePDFright()" icon="pi pi-refresh"></button>
    </div>
    <div *ngFor="let page of [].constructor(pdfDoc?.numPages || 0); let i = index">
      <canvas #pdfCanvas></canvas>
    </div>
  </div>
</div>
